import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {openOccurrencesCreateModal, openOccurrencesListModal} from "../../data/experimentalDesign/modalActions";

const OccurrenceManipulator = (props) => {
    return (
        <div className="square-tools__item" data-type={props.occurrenceType}>
            <div className="square-tools__container">
                <span className="square-tools__name">{props.occurrenceName}</span>
                <div className="square-tools__picto-container" draggable="false">
                    <i className="fas fa-plus" onClick={() => props.dispatch(openOccurrencesCreateModal(props.occurrenceName))} > </i>
                    <i className="fas fa-list" onClick={() => props.dispatch(openOccurrencesListModal(props.occurrenceName))}> </i>

                </div>
            </div>
        </div>
    )
};

OccurrenceManipulator.propTypes = {
    occurrenceType: PropTypes.string,
    occurrenceName: PropTypes.string
};

export default connect()(OccurrenceManipulator);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/OccurrenceManipulator.js